module.exports = __webpack_public_path__ + "img/border_trapezoid.28f0c562.svg";